export default __webpack_public_path__ + "ab790903dfa344b56e4f5a03b25519a0.png";